/**
 * Controladores.
 */
export const Endpoints = {
  APP: '_app',
  ASSINATURA: 'assinatura',
  ATUACAO: 'atuacao',
  AUTH: 'auth',
  CANDIDATO: 'candidato',
  COMARCA: 'comarca',
  CURSO: 'curso',
  DASHBOARD: 'dashboard',
  DEFENSOR: 'defensor',
  DEFENSORIA: 'defensoria',
  DIRETORIA: 'diretoria',
  DISTRITO: 'distrito',
  ESTAGIARIO: 'estagiario',
  ESTAGIO: 'estagio',
  ESTAGIO_EVENTOS: 'estagio_eventos',
  FERIADO: 'feriado',
  FOLHA_FREQUENCIA: 'folha_frequencia',
  FUNCAO: 'funcao',
  HISTORICO: 'historico',
  IMPORTACAO: 'importacao',
  INSTITUICAO_ENSINO: 'instituicao_ensino',
  LOTACAO: 'lotacao',
  MOVIMENTACAO: 'movimentacao',
  //MOVIMENTACAOREGISTROS: 'movimentacaoregistros',
  MOVIMENTACAOTIPO: 'movimentacaotipo',
  NUCLEO: 'nucleo',
  NOTIFICACAO: 'notificacao',
  TIPO_GASTO: 'tipo-gasto',
  GASTO: 'gasto',
  PAPEL: 'papel',
  PERIODO: 'periodo',
  PESSOA: 'pessoa',
  PREDIO: 'predio',
  PROCESSO_SELETIVO: 'processo-seletivo',
  REGRA: 'regra',
  RELATORIO: 'relatorio',
  RELATORIO_LOTACOES: 'lotacoes-estagiario/fullreport',
  RESPONSAVEL: 'responsavel',
  SETORES: 'setores',
  SOLAR: 'solar',
  SUBSTITUICAO: 'substituicao',
  TAREFA: 'tarefa',
  USUARIO: 'usuario',
  USUARIOBY: 'usuario/username/info',
  VARA: 'vara',
};
